import { permissionGuard } from './guards/permission.guard';
import { Routes } from '@angular/router';
import { LayoutComponent } from './components/layout/layout';
import { DashboardComponent } from './pages/dashboard/dashboard';
import { UsersComponent } from './pages/users/users';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then(m => m.LoginComponent),
    title: 'Entrar',
  },
  {
    path: '',
    component: LayoutComponent,
    canActivateChild: [permissionGuard],
    canActivate: [authGuard],
    children: [
      {
        path: '',
        component: DashboardComponent,
        title: 'Painel',
      },
      {
        path: 'users',
        component: UsersComponent,
        title: 'Usuários',
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile').then(m => m.ProfileComponent),
        title: 'Meu Perfil',
      },
      {
        path: 'requirements',
        loadComponent: () => import('./pages/requirements/list/requirement-list').then(m => m.RequirementListComponent),
        title: 'Requerimentos',
      },
      {
        path: 'requirements/new',
        loadComponent: () => import('./pages/requirements/wizard/requirement-wizard').then(m => m.RequirementWizardComponent),
        title: 'Novo Requerimento',
      },
      {
        path: 'requirements/trashed',
        loadComponent: () => import('./pages/requirements/list/requirement-list').then(m => m.RequirementListComponent),
        title: 'Histórico de Requerimentos',
      },
      {
        path: 'requirements/:id',
        loadComponent: () => import('./pages/requirements/detail/requirement-detail').then(m => m.RequirementDetailComponent),
        title: 'Detalhes do Requerimento',
      },
      {
        path: 'requirements/:id/edit',
        loadComponent: () => import('./pages/requirements/evaluation/requirement-evaluation').then(m => m.RequirementEvaluationComponent),
        title: 'Avaliar Requerimento',
      },
      {
        path: 'config-scholarships',
        loadComponent: () => import('./pages/config-scholarships/config-scholarships').then(m => m.ConfigScholarshipsComponent),
        title: 'Configuração de Bolsas',
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/settings/settings').then(m => m.SettingsComponent),
        title: 'Configurações do Sistema',
      },
      {
        path: 'reports',
        loadComponent: () => import('./pages/reports/reports').then(m => m.ReportsComponent),
        title: 'Relatórios',
      },
      {
        path: 'groups',
        loadComponent: () => import('./pages/groups/groups').then(m => m.GroupsComponent),
        title: 'Grupos',
      },
      {
        path: 'permissions',
        loadComponent: () => import('./pages/permissions/permissions').then(m => m.PermissionsComponent),
        title: 'Permissões',
      },
      {
        path: 'civil-statuses',
        loadComponent: () => import('./pages/civil-statuses/civil-statuses').then(m => m.CivilStatusesComponent),
        title: 'Estados Civis',
      },
      {
        path: 'document-types',
        loadComponent: () => import('./pages/document-types/document-types').then(m => m.DocumentTypesComponent),
        title: 'Tipos de Documento',
      },
      {
        path: 'education-levels',
        loadComponent: () => import('./pages/education-levels/education-levels').then(m => m.EducationLevelsComponent),
        title: 'Níveis de Escolaridade',
      },
      {
        path: 'institutions',
        loadComponent: () => import('./pages/institutions/institutions').then(m => m.InstitutionsComponent),
        title: 'Instituições',
      },
      {
        path: 'property-types',
        loadComponent: () => import('./pages/property-types/property-types').then(m => m.PropertyTypesComponent),
        title: 'Tipos de Propriedade',
      },
      {
        path: 'units',
        loadComponent: () => import('./pages/units/units').then(m => m.UnitsComponent),
        title: 'Unidades',
      },
    ],
  },
  {
    path: 'terms/:requirementId',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/terms/terms').then(m => m.TermsComponent),
    title: 'Termo de Bolsa',
  },
  {
    path: 'terms/:requirementId/respond',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/terms/terms').then(m => m.TermsComponent),
    title: 'Responder Termo de Bolsa',
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
